import { render, staticRenderFns } from "./form-modal.vue?vue&type=template&id=079746b5"
import script from "./form-modal.vue?vue&type=script&lang=js"
export * from "./form-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports